

























import { Vue } from "vue-property-decorator";
import type { stadium_info, stadium_business, stadium_business_info, stadium_business_stock, stadium_business_increase, stadium_reduced_cost } from "@/@types/stadium/stadium"
import Info from "@/views/invest/form/stadium_info_form.vue"
import Business from "@/views/invest/form/business.vue"
import BusinessInfo from "@/views/invest/form/business_info.vue"
import BusinessTime from "@/views/invest/form/business_time.vue"
import BusinessNew from "@/views/invest/form/business_new_time.vue"
import ReducedCost from "@/views/invest/form/stadium_reduced_cost_form.vue"
import Maintenance from "@/views/invest/form/maintenance.vue"
import Registration from "@/views/invest/form/registration.vue"
import Cooperation from "@/views/invest/form/cooperation.vue"
import Appointment from "@/views/invest/form/appointment.vue"
import Qualification from "@/views/invest/form/qualification.vue"
import StadiumGround from "@/views/invest/form/stadium_ground.vue"
import StadiumPhoto from "@/views/invest/form/stadium_photo.vue"

export default Vue.extend({
  name: "StadiumEstimateInfo",
  components: {
    Info,
    Business,
    BusinessInfo,
    BusinessTime,
    BusinessNew,
    ReducedCost,
    Maintenance,
    Registration,
    Cooperation,
    Appointment,
    Qualification,
    StadiumGround,
    StadiumPhoto,
  },
  props: {
    id: { type: String, default: "" },
  },
  data() {
    return {
      stadium: {
        id             : "",
        name           : "",
        status         : "",
        status_logs    : [],
        estimate_logs  : [],
        estimate_status: "0"
      } as any,
      /* 评估状态 */
      estimate_status: [
        { value: 0, label: "未开始", icon: "clock-circle", status: "#f60" },
        { value: 1, label: "审核中", icon: "clock-circle", status: "#10aeff" },
        { value: 2, label: "已通过", icon: "check-circle", status: "#4cd964" },
        { value: 3, label: "未通过", icon: "close-circle", status: "#f6383a" },
        { value: 4, label: "已撤销", icon: "clock-circle", status: "#D9D9D9" }
      ],
      editable        : false,
      stadium_info    : {} as stadium_info,
      stadium_business: {} as stadium_business,
      business_info   : {} as stadium_business_info,
      business_time   : {} as stadium_business_stock,
      business_new    : {} as stadium_business_increase,
      reduced_cost    : {} as stadium_reduced_cost
    }
  },
  methods: {
    async get_info() {
      const params = { estimate_id: this.id }
      const res = await this.$store.dispatch("invest/stadium_info", params);
      if (res.Code == 200) {
        const data = res.Data
        this.stadium = data
        this.handleStadiumInfo(data.cooperate_info)
        this.handleStadiumnBusiness(data.cooperate_info)
        this.handleStadiumBusinessInfo(data.cooperate_info)
        this.handleBusinessTime(data.cooperate_info)
        this.handleBusinessNewTime(data.cooperate_info)
        this.handleReducedCost(data.cooperate_info)
        this.handleMaintenance(data.cooperate_info)
        this.handleRegistration(data.cooperate_info)
        this.handleCooperation(data.cooperate_info)
        this.handleAppointment(data.cooperate_info)
        this.handleQualification(data.cooperate_info)
        this.handleStadiumGround(data.cooperate_info)
        this.handleStadiumPhoto(data.cooperate_info)
      }
    },
    /* 处理场馆信息 */
    handleStadiumInfo(data: any) {
      this.stadium_info = {
        name              : data.name,
        area_name         : data.area_name,
        province_id       : data.province_id,
        city_id           : data.city_id,
        county_id         : data.county_id,
        addr              : data.addr,
        rent_run_years    : data.rent_run_years,
        rent_surplus_years: data.rent_surplus_years,
        open_time         : data.open_time,
        rent_type         : data.rent_type,
        stadium_size      : data.stadium_size,
        ground_count      : data.ground_count,
        other_item        : data.other_item,
        other_size        : data.other_size,
      }
      const info = this.$refs.info as any
      info.init()
    },
    /* 处理经营主体 */
    handleStadiumnBusiness(data: any) {
      this.stadium_business = {
        enterprise_name        : data.enterprise_name,
        credit_code            : data.credit_code,
        legal_representative   : data.legal_representative,
        legal_phone            : data.legal_phone,
        legal_email            : data.legal_email,
        principal_name         : data.principal_name,
        principal_phone        : data.principal_phone,
        principal_email        : data.principal_email,
        publicity_material_addr: data.publicity_material_addr,
      }
    },
    /* 处理主要营业信息 */
    handleStadiumBusinessInfo(data: any) {
      this.business_info = {
        business_time_a      : data.business_time_a,
        business_time_p      : data.business_time_p,
        business_time_o      : data.business_time_o,
        work_days_price_low  : data.work_days_price_low,
        work_days_price_high : data.work_days_price_high,
        business_bill_count  : data.business_bill_count,
        business_bill_hour   : data.business_bill_hour,
        business_month_cost  : data.business_month_cost,
        business_finance_info: data.business_finance_info,
      }
      const info = this.$refs.business_info as any
      info.init()
    },
    /* 处理新增营业时间 */
    handleBusinessNewTime(data: any) {
      this.business_new = {
        business_time_new     : data.business_time_new,
        business_time_new_hour: data.business_time_new_hour,
      }
      const business = this.$refs.business_new as any
      business.init()
    },
    /* 处理营业存量 */
    handleBusinessTime(data: any) {
      this.business_time = {
        business_time     : data.business_time,
        business_time_hour: data.business_time_hour,
      }
      const info = this.$refs.business_time as any
      info.init()
    },
    /* 降本收益 */
    handleReducedCost(data: any) {
      this.reduced_cost = {
        save_payment    : data.save_payment,
        approval_payment: data.approval_payment,
      }
      const cost = this.$refs.reduced_cost as any
      cost.init()
    },
    /* 运维费 */
    handleMaintenance(data: any) {
      const maintenance = this.$refs.maintenance as any
      maintenance.init(data)
    },
    handleRegistration(data: any) {
      const registration = this.$refs.registration as any
      registration.init(data)
    },
    handleCooperation(data: any) {
      const cooperation = this.$refs.cooperation as any
      cooperation.init(data)
    },
    handleAppointment(data: any) {
      const appointment = this.$refs.appointment as any
      appointment.init(data)
    },
    handleQualification(data: any) {
      const qualification = this.$refs.qualification as any
      qualification.init(data)
    },
    handleStadiumGround(data: any) {
      const stadium_ground = this.$refs.stadium_ground as any
      stadium_ground.init(data)
    },
    handleStadiumPhoto(data: any) {
      const stadium_photo = this.$refs.stadium_photo as any
      stadium_photo.init(data)
    },
    async save(params: any) {
      const res            = await this.$store.dispatch("invest/save_stadium", params);
      if (res.Code == 200) {
        this.$success({
          content: "保存成功",
        })
      } else {
        this.$error({
          content: res.Message,
        })
      }
    },
    /* 提交审核 */
    submit() {
      const info = this.$refs.info as  any
      if (!info.check()) {
        this.$info({ content: "场馆信息未完整，无法提交" })
        return
      }
      const business = this.$refs.business as  any
      if (!business.check()) {
        this.$info({ content: "主体信息未完整，无法提交" })
        return
      }
      const business_info = this.$refs.business_info as  any
      if (!business_info.check()) {
        this.$info({ content: "经营信息未完整，无法提交" })
        return
      }
      const business_time = this.$refs.business_time as  any
      if (!business_time.check()) {
        this.$info({ content: "营业信息未完整，无法提交" })
        return
      }
      const reduced_cost = this.$refs.reduced_cost as  any
      if (!reduced_cost.check()) {
        this.$info({ content: "信息未完整，无法提交" })
        return
      }
      const maintenance = this.$refs.maintenance as  any
      if (!maintenance.check()) {
        this.$info({ content: "运维信息未完整，无法提交" })
        return
      }
      const registration = this.$refs.registration as  any
      if (!registration.check()) {
        this.$info({ content: "信息未完整，无法提交" })
        return
      }
      /* const cooperation = this.$refs.cooperation as  any
      if (!cooperation.check()) {
        this.$info({ content: "信息未完整，无法提交" })
        return
      } */
      const appointment = this.$refs.appointment as  any
      if (!appointment.check()) {
        this.$info({ content: "请上传收益与费用约定表" })
        return
      }
      const qualification = this.$refs.qualification as  any
      if (!qualification.check()) {
        this.$info({ content: "信息未完整，无法提交" })
        return
      }
      const stadium_ground = this.$refs.stadium_ground as  any
      if (!stadium_ground.check()) {
        this.$info({ content: "信息未完整，无法提交" })
        return
      }
      const stadium_photo = this.$refs.stadium_photo as  any
      if (!stadium_photo.check()) {
        this.$info({ content: "信息未完整，无法提交" })
        return
      }
      this.$confirm({
        content: "确认提交审核？",
        onOk   : () => {
          this.$emit("submit", 0)
        }
      })
    },
    close() {
      return false
    }
  },

  watch: {
    id(id: string) {
      if (id != "0") {
        this.$nextTick(() => {
          this.get_info();
        })
      }
    }
  }
})

